"use client";

import { useEffect, useState } from "react";
import styles from "./styles.module.scss";
import Image from "next/image";
export interface ToastProps {
  message: string;
  duration?: number;
  type: ToastType;
}
export enum ToastType {
  WARNING = "warning",
  ERROR = "error",
  SUCCESS = "success",
}
const imageConfig = {
  [ToastType.WARNING]: "https://acko-cms.ackoassets.com/warning_yello_74fdbc96bc.svg",
  [ToastType.SUCCESS]: "https://acko-cms.ackoassets.com/tick_green_6c607bd35a.svg",
  [ToastType.ERROR]: "https://acko-cms.ackoassets.com/icon_red_6839c475cd.svg",
};
export const Toast = () => {
  const [toast, setToast] = useState<ToastProps | null>(null);

  useEffect(() => {
    const handler = (event: CustomEvent<ToastProps>) => {
      setToast(event.detail);
      setTimeout(() => setToast(null), event.detail.duration || 7000);
    };

    window.addEventListener("generic-toast", handler as EventListener);

    return () => {
      window.removeEventListener("generic-toast", handler as EventListener);
    };
  }, []);

  if (!toast) return <div></div>;

  return (
    <div className={styles.toastWrapper} id="generic-toast">
      <Image src={imageConfig?.[toast?.type || ToastType.ERROR]} height={20} width={20} alt="war" />
      {toast?.message || "Something went wrong like sdsd sdfdfs sdf"}
    </div>
  );
};
